import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { AI_USAGE_ACTION_TYPE } from '../actions';

const initialState = {
  groups: {
    items: [],
    totalCount: 0,
    pageNumber: 1,
    pageSize: 0,
    totalPages: 0,
  },
  summary: null,
  groupItems: {},
  callsByMetricsId: {},
  chatMessagesBySessionId: {},
  stepInputByExecId: {},
  stepOutputByExecId: {},
  stepErrorByExecId: {},
  stepSystemPromptByExecId: {},
  stats: {
    costSeries: null,
    costLeaderboard: {},
    feedback: null,
  },
};

const aiUsageReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case AI_USAGE_ACTION_TYPE.GET_AI_USAGE_GROUPS:
        draft.groups.items = payload.items ?? [];
        draft.groups.totalCount = payload.totalCount ?? 0;
        draft.groups.pageNumber = payload.pageNumber ?? 1;
        draft.groups.pageSize = payload.pageSize ?? 0;
        draft.groups.totalPages = payload.totalPages ?? 0;
        break;

      case AI_USAGE_ACTION_TYPE.GET_AI_USAGE_SUMMARY:
        draft.summary = payload;
        break;

      case AI_USAGE_ACTION_TYPE.GET_AI_USAGE_GROUP_ITEMS:
        draft.groupItems[payload.groupKey] = payload.items;
        break;

      case AI_USAGE_ACTION_TYPE.GET_AI_USAGE_CALLS:
        draft.callsByMetricsId[payload.metricsId] = payload.items;
        break;

      case AI_USAGE_ACTION_TYPE.GET_CHAT_SESSION_MESSAGES:
        draft.chatMessagesBySessionId[payload.sessionId] = payload.messages;
        break;

      case AI_USAGE_ACTION_TYPE.GET_PROCESS_STEP_INPUT:
        draft.stepInputByExecId[payload.stepExecutionId] = payload.data;
        break;

      case AI_USAGE_ACTION_TYPE.GET_PROCESS_STEP_OUTPUT:
        draft.stepOutputByExecId[payload.stepExecutionId] = payload.data;
        break;

      case AI_USAGE_ACTION_TYPE.GET_PROCESS_STEP_ERROR:
        draft.stepErrorByExecId[payload.stepExecutionId] = payload.data;
        break;

      case AI_USAGE_ACTION_TYPE.GET_PROCESS_STEP_SYSTEM_PROMPT:
        draft.stepSystemPromptByExecId[payload.stepExecutionId] = payload.data;
        break;

      case AI_USAGE_ACTION_TYPE.GET_AI_STATS_COST_SERIES:
        draft.stats.costSeries = payload;
        break;

      case AI_USAGE_ACTION_TYPE.GET_AI_STATS_COST_LEADERBOARD:
        draft.stats.costLeaderboard[payload.dimension] = payload.items;
        break;

      case AI_USAGE_ACTION_TYPE.GET_AI_STATS_FEEDBACK:
        draft.stats.feedback = payload;
        break;

      case AI_USAGE_ACTION_TYPE.RESET_AI_USAGE_STATE:
      case RESET_STATE:
        return initialState;

      default:
        break;
    }
  });

export default aiUsageReducer;
